module.exports = __webpack_public_path__ + "media/images/icons/tablet-e803f00dca2983959753cb38031be654.svg";